export default "__VITE_ASSET__Dxupag6i__"